module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0036_001",
      "src": "Images/9781618371621_0036_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e1064236"
    }
  }, [_c('i', [_vm._v("Potato Halves with Smoked Salmon and Dill ")])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1064736"
    }
  }, [_c('b', [_vm._v("POTATO HALVES WITH "), _c('br'), _vm._v(" SMOKED SALMON AND DILL")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1065536"
    }
  }, [_c('b', [_c('i', [_vm._v("For ease of arranging and serving, cut a thin slice from the rounded side of each potato half before steaming so it will sit flat on your serving platter.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1066836"
    }
  }, [_c('b', [_vm._v("Prep: 20 minutes     Cook: 10 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1067436"
    }
  }, [_vm._v("18 baby red potatoes (1½ pounds), cut in half")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1068536"
    }
  }, [_vm._v("2 tablespoons water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1068836"
    }
  }, [_vm._v("1 tablespoon olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1069136"
    }
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1070136"
    }
  }, [_vm._v("¼ teaspoon coarsely ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1071036"
    }
  }, [_vm._v("¼ cup reduced-fat sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1072036"
    }
  }, [_vm._v("4 ounces sliced smoked salmon, cut into 36 pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1072336"
    }
  }, [_vm._v("1 tablespoon snipped fresh dill")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1072836"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In microwave-safe large bowl, place potatoes and water. Cover bowl with vented plastic wrap, and microwave on High 5 to 6 minutes or until just fork-tender.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1074136"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Meanwhile, prepare outdoor grill for direct grilling over medium heat.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1075236"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Transfer potatoes to jelly-roll pan. Brush potatoes all over with olive oil, and sprinkle with salt and pepper. Place potatoes on hot grill grate; cook 5 to 6 minutes or until lightly charred on both sides, turning once.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1077136"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Arrange potato halves, rounded sides down, on serving plate. Top each with about ¼ teaspoon sour cream, 1 piece salmon, and some dill. Makes 12 appetizer servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1079836"
    }
  }, [_vm._v("Each serving: About 75 calories, 3g protein, 12g carbohydrate, 2g total fat (1g saturated), 1g fiber, 4mg cholesterol, 290mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf66f87e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c22_r1.vue
// module id = 132
// module chunks = 0